import React from 'react';
import classnames from 'classnames'
import { withLocalize, Translate } from "react-localize-redux";
import AmlRequestForm from './amlRequestForm';
import AmlSearchCriteria from "../../search/aml/amlSearchCriteria";
import ModalInner from '../../layoutItems/modalInner';
import UnderlinedTitle from "../../common/underlinedTitle";

class AmlUpdateDataPopup extends React.Component {

    render() {
        return (
            <ModalInner close={() => this.props.close()} title={this.props.translate("Report.Aml.Request.Title")}>
                <div className="columns is-centered" style={{ marginBottom: 0 }}>
                    <div className="column is-narrow" style={{ paddingBottom: 0 }}>
                        {this.props.asCompany && <AmlRequestForm data={this.props.data} asPopup />}
                        {!this.props.asCompany && this.renderAmlPersonRequestForm()}
                    </div>
                </div>
                <div className="modal-inner-buttons">
                    <button onClick={() => this.props.close()} className={classnames('bb-button gradient-1-gray', { 'is-square': localStorage.locales_button_style === 'square' })}>
                        <Translate id="Common.No.Upper" />
                    </button>
                    <button onClick={() => this.submitAmlRequest()} className={classnames('bb-button gradient-1', { 'is-square': localStorage.locales_button_style === 'square' })}>
                        <Translate id="Common.Yes.Upper" />
                    </button>
                </div>
            </ModalInner>
        )
    }

    renderAmlPersonRequestForm = () => {
        const data = this.props.data;
        if (data === undefined || data === null)
            return null;

        return (
            <React.Fragment>
                <div style={{ marginBottom: "2em", marginTop: "0.5em" }}>
                    <UnderlinedTitle header={this.props.translate("Report.Aml.Request.Title")} />
                </div>
                <AmlSearchCriteria search={this.props.data.searchParams} />
                <div className="aml-warning-info">
                    <div>
                        <Translate id="Report.Aml.Request.PercentOfConfidenceDisclaimer" data={{ minConfidence: 95 }} options={{ renderInnerHtml: true }} />
                    </div>
                    <div>
                        <Translate id="Report.Aml.Request.ChargeWarning1" options={{ renderInnerHtml: true }} />
                    </div>
                </div>
            </React.Fragment>
        );
    }

    submitAmlRequest = () => {
        this.props.onSubmitAmlRequest();
        this.props.close();
    }
}

export default withLocalize(AmlUpdateDataPopup);